<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="showOrderInfo.orderNo ? '' : 'info'">
        {{ showOrderInfo.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="
          $jsTool.getOrderApprovalStatusType(
            showOrderInfo.orderApprovalStatusEnum
          )
        "
        >{{ showOrderInfo.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="showOrderInfo.orderNo ? '' : 'info'">
        {{ showOrderInfo.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="2">
      {{ showOrderInfo.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="收入类型" span="3">
      {{ showOrderInfo.incomeType }}
    </el-descriptions-item>
    <el-descriptions-item label="收入信息" span="3">
      <el-table
        :data="
          showOrderInfo && showOrderInfo.fundAccountList
            ? showOrderInfo.fundAccountList
            : []
        "
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        stripe
        max-height="300px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="fundAccount"
          label="资金账户"
          width="200"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              <el-image
                style="width: 18px; height: 18px"
                fit="cover"
                class="fm-margin-right-5"
                :src="
                  $jsTool.getFundAccountImageSrc(
                    scope.row.fundAccount.fundAccountTypeEnum
                  )
                "
              ></el-image>
              {{ scope.row.fundAccount.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="收入金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.itemAmount"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="200"
          align="left"
          header-align="center"
        >
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item label="单据金额" span="1">
      <FmAmount :amount="showOrderInfo.orderAmount"></FmAmount>
    </el-descriptions-item>
    <el-descriptions-item label="业务员" span="2">
      {{ showOrderInfo.saleUserList.map((d) => d.user.name).join("、") }}
    </el-descriptions-item>
    <el-descriptions-item label="收入凭证" span="3">
      <OrderImageList
        :list="showOrderInfo.collectVoucherImageList"
        name="收入凭证图片"
      ></OrderImageList>
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="showOrderInfo.remark ? '' : 'warning'">{{
        showOrderInfo.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="流程信息" span="3">
      <OrderStep
        :orderInfo="showOrderInfo"
        :displayTime="displayTime"
      ></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>
  
  <script>
export default {
  name: "Fmerpv2WebOtherIncomeOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = newVal;
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:OtherIncomeOrder:NeedApproval",
        "Order:OtherIncomeOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:OtherIncomeOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:OtherIncomeOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.otherIncomeOrder_findById(
        this.orderInfo.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>
  
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/OtherIncomeOrderInfo.vue